import {
  PERCENTAGE_SECTION,
  UNIT_OF_MEASURE_SECTION,
  centralStackedCategories,
  centralStackedDetailSeriesByCategory,
  centralStackedSeriesByCategory
} from './constants'

export const trasformDataForCentralStackedChart = (
  data,
  t,
  DOMAIN_NAME,
  isDetail
) => {
  const trasformedData = []
  centralStackedCategories.forEach((cat) => {
    const obj = {
      category: t(`${DOMAIN_NAME}.${cat.toUpperCase()}`)
    }

    const seriesByCategory = isDetail
      ? centralStackedDetailSeriesByCategory
      : centralStackedSeriesByCategory

    seriesByCategory[cat].forEach((serie) => {
      obj[serie] = data?.[serie]
    })
    trasformedData.push(obj)
  })
  return trasformedData
}

export const trasformDataForCentralPieChart = (
  data,
  t,
  DOMAIN_NAME,
  isDetail,
  colorTheme
) => {
  const seriesByCategory = isDetail
    ? centralStackedDetailSeriesByCategory
    : centralStackedSeriesByCategory
  const pieSeries = Object.values(seriesByCategory).flat()

  const trasformedData = pieSeries.reduce((acc, curr) => {
    acc.push({
      category: t(`${DOMAIN_NAME}.${curr.toUpperCase()}`),

      value: data?.[curr],
      color: colorTheme[curr]
    })
    return acc
  }, [])

  return trasformedData
}

export const getFilterModelFromFilterBar = (filters) => {
  if (!filters) {
    return {}
  }

  return Object.entries(filters).reduce((acc, [key, value]) => {
    const filterValues =
      value === undefined
        ? []
        : Object.entries(value)
            .filter(([_, enabled]) => enabled)
            .map(([value]) => value)

    const filterBody = {
      filterType: 'set',
      type: 'in',
      values: filterValues
    }

    return {
      ...acc,
      [key]: filterBody
    }
  }, {})
}

const getValues = (t, value, item) => {
  // if (value === 'date') return Object.values(item)
  if (value === UNIT_OF_MEASURE_SECTION || value === PERCENTAGE_SECTION)
    return [item]
  return Object.keys(
    Object.fromEntries(Object.entries(item).filter(([key, val]) => val))
  )
}

export const reduceFilters = (t, DOMAIN_NAME, filters) => {
  const entries = Object.entries(filters)
  return entries.reduce((acc, inc) => {
    const filterKey = t(`${DOMAIN_NAME}.Filter.${inc[0].toUpperCase()}`)
    return {
      ...acc,
      [filterKey]: getValues(t, inc[0], inc[1])
    }
  }, {})
}
